import React from "react";

function Label({htmlFor, title, required}){
    return <label htmlFor={htmlFor}>
        <small className={'font-weight-bold'}>{title} {required && <span className={"text-danger"}>*</span>}</small>
    </label>
}
export default Label;
